import { IonRow } from '@ionic/react';

interface DataTableRowProps {
  children: React.ReactNode;
}

export const DataTableRow = ({ children }: DataTableRowProps) => {
  return <IonRow style={{ width: '100%' }}>{children}</IonRow>;
};
